export default {
  watch: {
    $route: 'setPageType',
  },
  data() {
    return {
      initialValue: {},
      tasks: [],
      id: null,
      acceptOrderKey: null,
      //照会モード
      isViewMode: false,
      //承認後変更モード
      isApprovaledMode: false,
      //承認前変更モード
      isUpdateMode: false,
      //登録モード
      isAddMode: false,
      //編集可否
      isEditability: true,
    }
  },
  provide() {
    return {
      pageComponent: this,
    }
  },
  mounted() {
    this.setPageType()
  },
  methods: {
    // 設定ページtype
    setPageType() {
      //IDを取得する
      this.id = this.$route.query.id
      //受注キーを取得する
      this.acceptOrderKey = this.$route.query.acceptOrderKey
      //照会フラグ
      this.isViewMode =
        this.$route.query.type == this.$divisions.pageViewEnum.view.code
      //変更フラグ
      this.isUpdateMode =
        this.$route.query.type == this.$divisions.pageViewEnum.update.code
      //登録フラグ
      this.isAddMode =
        this.$route.query.type == this.$divisions.pageViewEnum.add.code
    },
    registerPromise(p) {
      if (p) {
        this.tasks.push(p)
      }
    },

    //複数の非同期を処理する
    async syncComponentTask() {
      if (this.tasks.length > 0) {
        return await Promise.all(this.tasks)
      }
    },

    //データをフォームダーターに反映する
    mergeFormData(prop, data) {
      let form = this.$refs['form']
      this.setFormData(form, prop, data)
    },
    setFormData(form, prop, data) {
      if (prop) {
        this.$baseLodash.set(this.initialValue, prop, data)
        this.$set(form.model, prop, data)
      } else {
        this.$baseLodash.forOwn(data, (value, key) => {
          //delete form.model[key]
          this.$baseLodash.set(this.initialValue, key, value)
          this.$set(form.model, key, value)
        })
      }
    },
    resetForm(val) {
      if (!val) {
        this.form = this.$options.data().form
        this.$refs['form'].clearValidate()
      }
    },
    // 計算予定粗利率
    getEstimatedGrossInterest(sum1, sum3) {
      // 予定売上額が０円の場合は、0.0で表示する。
      if (sum1 == 0) {
        return 0
      }
      let crudeInterestRate = this.$baseLodash.floor(
        this.$baseLodash.divide(sum3, sum1) * 100,
        1
      )
      // 但し、粗利率＜-999.9の場合は、-999.9で表示し
      if (crudeInterestRate < -999.9) {
        return -999.9
      } else {
        return crudeInterestRate
      }
    },
  },
}
